/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  vehicles: [],
  error: null,
};

const getters = {
  vehicles: state => state.vehicles,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/permits/${payload.id}/vehicles/list`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch vehicles');
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/vehicles/${payload.id}`)
      .then(() => {
        state.error = null;
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, vehicles) {
    state.vehicles = vehicles.data;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/permits/vehicles.js